import React, { createContext, useContext, useState } from "react";
import { useLocation } from "wouter";

export type BreadcrumbItem = {
  label: string;
  path?: string;
};

type BreadcrumbContextType = {
  breadcrumbs: BreadcrumbItem[];
  setBreadcrumbs: (items: BreadcrumbItem[]) => void;
  pushBreadcrumb: (item: BreadcrumbItem) => void;
};

const BreadcrumbContext = createContext<BreadcrumbContextType | null>(null);

export function BreadcrumbProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbItem[]>([]);

  const pushBreadcrumb = (item: BreadcrumbItem) => {
    setBreadcrumbs((prev) => {
      // Avoid duplicates
      if (prev[prev.length - 1]?.label === item.label) {
        return prev;
      }

      return [...prev, item];
    });
  };

  return (
    <BreadcrumbContext.Provider
      value={{ breadcrumbs, setBreadcrumbs, pushBreadcrumb }}
    >
      {children}
    </BreadcrumbContext.Provider>
  );
}

export function useBreadcrumbs() {
  const ctx = useContext(BreadcrumbContext);

  if (!ctx) {
    throw new Error("useBreadcrumbs must be used inside BreadcrumbProvider");
  }

  return ctx;
}